import { useEffect, useState } from 'react'
import {
  NewsArticle,
  NewsImage,
  ModalDialog,
  Mtds,
  BugIcon,
  SparkleIcon
} from 'prove-common'
import { MarkdownContent } from '../markdown-content/MarkdownContent'

type WhatsNewProps =
  | { article: NewsArticle; open?: never; onClose?: never }
  | { article: NewsArticle; open: boolean; onClose: () => void }

export const WhatsNew = ({ article, open, onClose }: WhatsNewProps) => {
  const isControlled = open !== undefined
  const [isOpen, setIsOpen] = useState(false)
  const dismissedArticleId = localStorage.getItem('dismissedArticleId')

  useEffect(() => {
    if (isControlled) return
    if (
      article?.id != null &&
      (dismissedArticleId == null ||
        dismissedArticleId !== article.id.toString())
    )
      setIsOpen(true)
  }, [article, dismissedArticleId, isControlled])

  const handleClose = (): void => {
    if (isControlled) {
      onClose()
    } else {
      setIsOpen(false)
      if (article?.id != null)
        localStorage.setItem('dismissedArticleId', article.id.toString())
    }
  }

  const visible = isControlled ? open : isOpen

  if (article == null || !visible) return null

  return (
    <ModalDialog
      closedby='any'
      open={visible}
      onClose={handleClose}
      className='flex flex-col p-0! lg:flex-row lg:min-w-[1100px]! lg:max-h-[90vh]'
    >
      <div className='bg-linear-to-b from-main-surface-tinted to-neutral-surface-tinted w-full order-1 lg:order-2 lg:max-w-[600px] overflow-auto lg:max-h-[90vh]'>
        <NewsImage className='w-full h-auto lg:w-auto' articleId={article.id} />
      </div>

      <Mtds.Grid className='order-2 p-8 lg:order-1 lg:w-[500px] shadow-2xl lg:shadow-xl z-50 overflow-auto lg:max-h-[90vh]'>
        <Mtds.Grid>
          {article?.icon === 'bug' ? (
            <Mtds.Tag data-color='danger' data-icon='none' data-size='md'>
              <BugIcon /> Feilretting
            </Mtds.Tag>
          ) : (
            <Mtds.Tag data-color='warning' data-icon='none' data-size='md'>
              <SparkleIcon /> Nye funksjoner
            </Mtds.Tag>
          )}
          <MarkdownContent content={article.subject} />
        </Mtds.Grid>
        <Mtds.Button
          onClick={handleClose}
          data-variant='secondary'
          data-cy='whats-new-close-button'
        >
          Lukk
        </Mtds.Button>
      </Mtds.Grid>
    </ModalDialog>
  )
}
